import { Resp } from '../../../interfaces/response'
import { endpoint } from '../../http/api-endpoint'

// KeyboardShortcutController under 'keyboard-shortcuts/me' in both
// customer-api.php and workshop-api.php: the signed-in user's own
// preferences, always scoped to Auth::id() server side.

export interface ApiShortcutBinding {
    id?: number
    scope: string
    keys: string
    command_id?: string | null
    action_type?: string | null
    action_payload?: Record<string, unknown> | null
    label?: string | null
}

export interface ApiShortcutPreferences {
    settings: {
        enabled: boolean
        rules: Array<{ command?: string, layer?: 'global' | 'screen', on?: string }>
    }
    bindings: Array<ApiShortcutBinding>
}

export interface KeyboardShortcutMeRequest {
    userable: string
}

export type KeyboardShortcutMeResponse = Resp<ApiShortcutPreferences>

export const KeyboardShortcutMe = endpoint<KeyboardShortcutMeRequest, KeyboardShortcutMeResponse>({
    method: 'GET',
    url: ':userable/keyboard-shortcuts/me'
})

export const SaveKeyboardShortcutMe = endpoint<KeyboardShortcutMeRequest & ApiShortcutPreferences, KeyboardShortcutMeResponse>({
    method: 'PUT',
    url: ':userable/keyboard-shortcuts/me'
})

export const ResetKeyboardShortcutMe = endpoint<KeyboardShortcutMeRequest, KeyboardShortcutMeResponse>({
    method: 'DELETE',
    url: ':userable/keyboard-shortcuts/me'
})
